import classNames from 'classnames';
import { css } from 'lit';

import { type AdStatus, type AdType } from '@schibsted-nmp/advertising-shared';

export function getClassNameByStatus(status: AdStatus) {
  return classNames({
    'advt-loaded': status === 'available' || status === 'loaded',
    // ! Beware that advt-empty contains {display: none} that can break lazy loading (AD-311)
    'advt-empty': status === 'error' || status === 'collapsedOnCollision'
  });
}

export function getClassNameByType(type: AdType) {
  return classNames({
    'native-ad': type === 'native',
    'video-ad': type === 'video',
    'banner-ad': type === 'banner' || type === 'adnami',
    'sponsored-content': type === 'sponsored-content',
    'takeover-ad': type === 'takeover',
    'intermingles-ad': type === 'intermingles',
    'audience-pixel-ad': type === 'audience-pixel',
    'top1-wallpaper-ad': type === 'top1-wallpaper'
  });
}

export default css`
  :host {
  }
`;
